module.exports = __webpack_public_path__ + "static/media/angle-double-down.c894722f.svg";